export default (name, value, count, days) => {
  const date = new Date();
  date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * days);

  let parts = localStorage.getItem(name);
  if (!parts || parts === 'undefined') {
    localStorage.setItem(name, value);
    return;
  }

  parts = parts.split(',');
  if (parts.length > 0) {
    // search same item and delete
    // if already have , delete it
    for (let i = 0; i < parts.length; i += 1) {
      if (value.toString() === parts[i]) {
        parts.splice(i, 1);
      }
    }
    parts.push(value);

    // if over 50, just do 50
    let newparts = [];
    if (parts.length > count) {
      for (let i = parts.length - count; i < parts.length; i += 1) {
        newparts.push(parts[i]);
      }
    } else {
      newparts = parts;
    }
    localStorage.setItem(name, newparts.join(','));
  }
};
